import axios from 'axios';

const mockrecord = {
    state: {  
		mockrecords : []
	},	
	mutations: {		
		mockrecords_success(state, payload){			
			state.markrecords = payload	
		}	
	},
	actions: {
        getmockrecord(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Mockrecord/Getmockrecord', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {						
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},			
		getmockrecordbyid(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Mockrecord/Getmockrecordbyid', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},						
		mockrecordregistration(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Mockrecord/Registermockrecord', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
        },        
	}
}

export default mockrecord